var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: this.scrollTo,
    offset: this.vw > 768 ? -this.navHeight : -this.navHeightSmall,
  }),expression:"{\n    el: this.scrollTo,\n    offset: this.vw > 768 ? -this.navHeight : -this.navHeightSmall,\n  }"}],staticClass:"btn btn-primary Regular uppercase",class:{ 'btn-primary-inv': this.type == 'inv' },attrs:{"to":_vm.to}},[_c('span',[_vm._v("Partecipa")])])}
var staticRenderFns = []

export { render, staticRenderFns }